import React from "react";

import { StyledAnchor, StyledNav } from "./styles";
import { useCustomNavigate } from "utils";

const shouldRenderAnchor = (path: string) => {
  const basePath = path.includes("?") ? path.split("?")[0] : path;
  return !window.location.pathname.startsWith(basePath);
};

export function Navigation() {
  const navigate = useCustomNavigate();

  const handleProps = (path: string, element: "a" | "nav") => {
    return element === "nav"
      ? {
          isActive: window.location.pathname.startsWith(path),
          onClick: () => navigate(path),
        }
      : {
          href: path,
          isActive: window.location.pathname.startsWith(path),
        };
  };

  const renderItem = (path: string, text: string) => {
    return shouldRenderAnchor(path) ? (
      <StyledAnchor key={path} {...handleProps(path, "a")}>
        {text}
      </StyledAnchor>
    ) : (
      <StyledNav key={path} {...handleProps(path, "nav")}>
        {text}
      </StyledNav>
    );
  };

  const renderItemOnRoot = (path: string, text: string) => {
    const isRoot = window.location.pathname === "/";
    const isKbPath = path.startsWith("/kb");
    const isSupportPath = path.startsWith("/support");

    if (isRoot && isKbPath) {
      return (
        <StyledNav key={path} {...handleProps(path, "nav")}>
          {text}
        </StyledNav>
      );
    }

    if (isRoot && isSupportPath) {
      return (
        <StyledAnchor key={path} {...handleProps(path, "a")}>
          {text}
        </StyledAnchor>
      );
    }

    return renderItem(path, text);
  };

  // const regex =
  //   // eslint-disable-next-line no-useless-escape
  //   /^\/support\/(ticket\/[^\/]+|new-ticket\/(erp|envios|loja|conta-digital))$/;
  // const shouldRenderMyRequestMenu = regex.test(window.location.pathname);
  const shouldRenderMyRequestMenu = window.location.pathname !== "/support";

  const items = [
    {
      path: "/kb",
      text: "central de ajuda",
    },
    ...(shouldRenderMyRequestMenu
      ? [
          {
            path: "/support?realm=tiny",
            text: "meus chamados",
            isActive: true,
          },
        ]
      : []),
  ];

  return <>{items.map(({ path, text }) => renderItemOnRoot(path, text))}</>;
}
